import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { ExclamationTriangleIcon, ClockIcon } from '@heroicons/react/24/outline'

function PendingApproval() {
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <img
            className="h-12 w-auto"
            src="/logo.png"
            alt="Domus"
          />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Cuenta Pendiente de Aprobación
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
              <ClockIcon className="h-6 w-6 text-yellow-600" />
            </div>
            
            <h3 className="mt-4 text-lg font-medium text-gray-900">
              ¡Bienvenido a Domus!
            </h3>
            
            <p className="mt-2 text-sm text-gray-600">
              Hola <span className="font-medium">{user?.name || user?.email}</span>,
              tu cuenta ha sido creada exitosamente.
            </p>
            
            <div className="mt-4 p-4 bg-yellow-50 rounded-md">
              <div className="flex">
                <div className="flex-shrink-0">
                  <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-yellow-800">
                    Esperando Aprobación
                  </h3>
                  <div className="mt-2 text-sm text-yellow-700">
                    <p>
                      Tu cuenta está pendiente de aprobación por un administrador. 
                      Serás notificado por email una vez que tu cuenta sea activada.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-6 space-y-4">
              <div className="text-sm text-gray-500">
                <p>Mientras tanto, puedes:</p>
                <ul className="mt-2 list-disc list-inside space-y-1">
                  <li>Verificar tu email para confirmar tu dirección</li>
                  <li>Contactar al administrador si tienes preguntas</li>
                  <li>Revisar la documentación de Domus</li>
                </ul>
              </div>
              
              <div className="flex flex-col space-y-3">
                <button
                  type="button"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                  onClick={() => window.location.reload()}
                >
                  Verificar Estado
                </button>
                
                <button
                  type="button"
                  className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                  onClick={logout}
                >
                  Cerrar Sesión
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-600">
            ¿Necesitas ayuda? Contacta a{' '}
            <a 
              href="mailto:admin@domus.local" 
              className="text-primary-600 hover:text-primary-500"
            >
              admin@domus.local
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default PendingApproval